var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 0L17 0C17.5523 0 18 0.449219 18 1L18 19C18 19.5508 17.5523 20 17 20L1 20C0.447723 20 0 19.5508 0 19L0 1C0 0.449219 0.447723 0 1 0ZM4 10L4 12L6 12L6 10L4 10ZM4 14L4 16L6 16L6 14L4 14ZM8 10L8 12L10 12L10 10L8 10ZM8 14L8 16L10 16L10 14L8 14ZM12 10L12 16L14 16L14 10L12 10ZM4 4L4 8L14 8L14 4L4 4Z",
    fill: "#818181",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.c3557749db46ae1092ed1df54d55d69b.svg";
export { ForwardRef as ReactComponent };